import {
    AnimationBaseController,
    GameApiBase, GameRandom,
    GameStorageManager, IAnimationControllerChildControllerConfiguration
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";

import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";
import { SoundConstants } from "../../../Constants/SoundConstants";
import { LeaderboardToolTipsConstants } from "../../../Constants/LeaderboardToolTipsConstants";
import { scaleModal } from "../../../Utils/DialogScale";
import { SoundLevels } from "../../../Constants/SoundConstants";
import { AnalyticsConstants } from "../../../Constants/AnalyticsConstants";
export interface ILeaderBoardListScreenControllerOptions {
}
export class LeaderBoardScreenController extends AnimationBaseController {
    $model: GameModel;
    private maxItemsView = 5;
    private nextItemsView = this.maxItemsView;
    private previousItemsView = 0;
    private interval: any;

    public constructor(@Inject private _options: ILeaderBoardListScreenControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private _arenaApi: GameApiBase) {
        super("LeaderBoardScreenController");
        console.log('LeaderBoardScreenController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.LEADER_BOARD_MODAL_JSON,
            libraryName: "leaderboard",
            childControllers: {
                RestartButton: {
                    instanceName: "btn_play_again",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.replay();
                        }
                    }
                },
                VoteButton: {
                    instanceName: "btn_vote",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.vote();
                        }
                    }
                },

                Icon0: {
                    instanceName: 'b0',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                0,
                                this.$childControllers.get<AnimationBaseController>('Icon0').x,
                            );
                        }
                    }
                },
                Icon1: {
                    instanceName: 'b1',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                1,
                                this.$childControllers.get<AnimationBaseController>('Icon1').x,
                            );
                        }
                    }
                },
                Icon2: {
                    instanceName: 'b2',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                2,
                                this.$childControllers.get<AnimationBaseController>('Icon2').x,
                            );
                        }
                    }
                },
                Icon3: {
                    instanceName: 'b3',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                3,
                                this.$childControllers.get<AnimationBaseController>('Icon3').x,
                            );
                        }
                    }
                },
                Icon4: {
                    instanceName: 'b4',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                4,
                                this.$childControllers.get<AnimationBaseController>('Icon4').x,
                            );
                        }
                    }
                },
                Icon5: {
                    instanceName: 'b5',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                5,
                                this.$childControllers.get<AnimationBaseController>('Icon5').x,
                            );
                        }
                    }
                },
                Icon6: {
                    instanceName: 'b6',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                6,
                                this.$childControllers.get<AnimationBaseController>('Icon6').x,
                            );
                        }
                    }
                },
                IconBB: {
                    instanceName: 'bb',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.showPopup(
                                7,
                                this.$childControllers.get<AnimationBaseController>('IconBB').x,
                            );
                        }
                    }
                },
                ClickBack: {
                    instanceName: 'click_area',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            const toolTip = this.getDisplayObjectByQuery('pop_up_icons')[0];
                            toolTip.visible = false;
                        }
                    }
                }
            },
            modelWatch: {}
        };
    }

    private async vote() {
        await this._gameLogic.sendAnalitics(AnalyticsConstants.VOTE);
        window.open('https://hh.ru/employer/3809', '_blank');
        console.log('vote');
    }

    private async replay() {
        await this._gameLogic.sendAnalitics(AnalyticsConstants.PLAY_AGAIN);
        this._gameLogic.hideModal();
        this._gameLogic.unpause();
        this._gameLogic.startNewGame();
        this._gameLogic.hideModal();
        this._gameLogic.showTapToStart();
    }

    private showPopup(index: number, posX: number) {
        if (this._gameLogic.getBonusCount() < 3 && index === 7) {
            return;
        }
        const toolTip = this.getDisplayObjectByQuery('pop_up_icons')[0];



        const sc = 1.5;
        toolTip.x = (index === 3 || index === 6 || index == 1) ? posX + 210 : posX + 160;
        toolTip.y = -430;
        this.getDisplayObjectByQuery('pop_up_icons.bg_tool')[0].scale.x = (index === 3 || index === 6 || index == 1) ? -sc : sc;
        this.getDisplayObjectByQuery('pop_up_icons.bg_tool')[0].scale.y = sc;
        this.setTextByQuery('pop_up_icons.txt', '123');
        this.getDisplayObjectByQuery('pop_up_icons.txt')[0].x = (index === 3 || index === 6 || index == 1) ? -710 : -130
        this.setTextByQuery('pop_up_icons.txt', LeaderboardToolTipsConstants.getText(index));
        this.setTextStyleByQuery('pop_up_icons.txt', { fontSize: 24 })

        const posY = [-36, -30, -30, -54, -54, -54, -36, -16];
        this.getDisplayObjectByQuery('pop_up_icons.txt')[0].y = posY[index];


        toolTip.visible = true;

        clearTimeout(this.interval);
        this.interval = setTimeout(() => {
            toolTip.visible = false;

        }, 3000);

    }

    private setInterval() {

    }

    protected onInitialize(): void {
        this.scaleX = this.scaleY = 0.8;

        this.$childControllers.get<AnimationBaseController>('ClickBack').alpha = 0.1;
        if (this.$model.bonusCount === 3) {
            this.$model.totalBonusCount++;
        }

        if (this.$model.totalBonusCount === 0) {

            this.$childControllers.get<AnimationBaseController>('IconBB').alpha = 0.5;
            this.$childControllers.get<ButtonController>('IconBB').disabled();
            this.setTextByQuery(`sb`, '0');
        } else {
            this.$childControllers.get<AnimationBaseController>('IconBB').alpha = 1;
            this.setTextByQuery(`sb`, this.$model.totalBonusCount.toString());
            this.$childControllers.get<ButtonController>('IconBB').enabled();
        }

        for (let i = 0; i < this.$model.collectAchievements.length - 1; i++) {
            this.setTextByQuery(`s${i}`, this.$model.collectAchievements[i].toString());
        }

        const sorted = this.$model.leaderboard.sort((a, b) => (a.score < b.score) ? 1 : -1);
        let isPlayerTop = false;
        for (let i = 0; i < sorted.length; i++) {
            if (i === 5) {
                break;
            }
            this.setTextByQuery(`n${i}`, sorted[i].name);
            this.setTextByQuery(`w${i}`, sorted[i].score.toString());
            if (this.$model.player.id === sorted[i].id) {
                isPlayerTop = true;
            }
        }
        if (isPlayerTop) {
            if (sorted.length >= 5) {
                this.setTextByQuery(`n${5}`, sorted[5].name);
                this.setTextByQuery(`w${5}`, sorted[5].score.toString());
                this.setTextByQuery(`your_position`, '6');
            } else {
                this.setTextByQuery(`n5`, '');
                this.setTextByQuery(`w5`, '');
                this.setTextByQuery(`your_position`, '');
            }

        } else {

            let playerPosition = 0;
            for (let i = 0; i < sorted.length; i++) {
                if (sorted[i].id === this.$model.player.id) {
                    playerPosition = i;
                    break;
                }
            }

            this.setTextByQuery(`n5`, this.$model.player.name);
            this.setTextByQuery(`w5`, this.$model.player.totalScore.toString());
            this.setTextByQuery(`your_position`, playerPosition.toString());
        }

        this.setTextByQuery('winCount', `${this._gameLogic.getWinCoins()} очк${this._getEnding(this._gameLogic.getWinCoins())}!`);
        this.getDisplayObjectByQuery('symbol_new_record')[0].visible = (this.$model.player.score >= this.$model.player.totalScore);
        console.log('score', this.$model.player.score, this.$model.player.totalScore)
        if (this.getDisplayObjectByQuery('symbol_new_record')[0].visible) {
            this.soundManager.playSound(SoundConstants.NEW_RECORD, 0, SoundLevels.uiAction);
        }

        /*const ar = [3, 6, 4, 7, 2, 1, 5]
        for (let i = 0; i < 7; i++) {
           this.$childControllers.get<AnimationBaseController>(`Icon${i}`).gotoAndStop(ar[i]);
        }*/

        this.getDisplayObjectByQuery('pop_up_icons')[0].visible = false;
    }

    private _getEnding(value: number): string {
        let n = Math.abs(value);
        n = n % 100;
        if (n >= 5 && n <= 20) {
            return 'ов';
        }
        n = n % 10;
        if (n === 1) {
            return 'о';
        }
        if (n >= 2 && n <= 4) {
            return 'а';
        }
        return 'ов';
    }

    onResize(width: number, height: number, scale: number) {
        scaleModal(this, width, height, scale * 1.2, 1496, 1064);
    }
    protected onUpdate(frameRate: number): void {
    }

}

